import { fetchPlayerFirestoreAPI } from '../../../firebase/firebaseAPICalls/FirebaseAPICallsPlayer';
import { isValidObject, isValidString } from '../../Validity';

// ---------------------------------------------------------------------------------------------------------
// Goal
// ---------------------------------------------------------------------------------------------------------

export const databaseGoalToLocalGoal = async (goal: any) => {
    const updatedGoal = { ...goal };
    if (goal.team === 'our' && isValidString(goal.scorerId)) {
        const scorerDoc = await fetchPlayerFirestoreAPI(goal.scorerId);
        if (scorerDoc.exists && !scorerDoc.data()?.deleted) {
            updatedGoal.scorerName = scorerDoc.data()?.name;
        } else {
            updatedGoal.scorerName = '';
        }
    } else {
        updatedGoal.scorerName = '';
    }

    if (goal.team === 'our' && isValidString(goal.assist1Id)) {
        const assistDoc = await fetchPlayerFirestoreAPI(goal.assist1Id);
        if (assistDoc.exists && !assistDoc.data()?.deleted) {
            updatedGoal.assist1Name = assistDoc.data()?.name;
        } else {
            updatedGoal.assist1Name = '';
        }
    } else {
        updatedGoal.assist1Name = '';
    }
    return updatedGoal;
};

export const databaseGoalsToLocalGoals = async (goals: any[]) => {
    if (isValidObject(goals)) {
        const updatedGoals = Array<any>(goals.length);
        await (Promise.all(goals.map(async (goal, index) => {
            updatedGoals[index] = await databaseGoalToLocalGoal(goal);
        })));
        return updatedGoals;
    }
    return [];
};

// ---------------------------------------------------------------------------------------------------------
// Highlight
// ---------------------------------------------------------------------------------------------------------

export const databaseHighlightPerPlayerToLocalHighlightPerPlayer = async (highlight: any) => {
    const updatedHighlight = { ...highlight };
    if (isValidString(highlight.playerId)) {
        const playerDoc = await fetchPlayerFirestoreAPI(highlight.playerId);
        if (playerDoc.exists && !playerDoc.data()?.deleted) {
            updatedHighlight.playerName = playerDoc.data()?.name;
        } else {
            updatedHighlight.playerName = '';
        }
    } else {
        updatedHighlight.playerName = '';
    }

    return updatedHighlight;
};

export const databaseHighlightsPerPlayerToLocalHighlightsPerPlayer = async (highlights: any[]) => {
    if (isValidObject(highlights)) {
        const updatedHighlights = Array<any>(highlights.length);
        await (Promise.all(highlights.map(async (highlight, index) => {
            updatedHighlights[index] = await databaseHighlightPerPlayerToLocalHighlightPerPlayer(highlight);
        })));
        return updatedHighlights;
    }
    return [];
};

// ---------------------------------------------------------------------------------------------------------
// Penalty
// ---------------------------------------------------------------------------------------------------------

export const databasePenaltyToLocalPenalty = async (penalty: any) => {
    const updatedPenalty = { ...penalty };
    if (penalty.team === 'our' && isValidString(penalty.playerId)) {
        const playerDoc = await fetchPlayerFirestoreAPI(penalty.playerId);
        if (playerDoc.exists && !playerDoc.data()?.deleted) {
            updatedPenalty.playerName = playerDoc.data()?.name;
        } else {
            updatedPenalty.playerName = '';
        }
    } else {
        updatedPenalty.playerName = '';
    }

    return updatedPenalty;
};

export const databasePenaltiesToLocalPenalties = async (penalties: any[]) => {
    if (isValidObject(penalties)) {
        const updatedPenalties = Array<any>(penalties.length);
        await (Promise.all(penalties.map(async (penalty, index) => {
            updatedPenalties[index] = await databasePenaltyToLocalPenalty(penalty);
        })));
        return updatedPenalties;
    }
    return [];
};

// ---------------------------------------------------------------------------------------------------------
// Face Off
// ---------------------------------------------------------------------------------------------------------

export const databaseFaceOffToLocalFaceOff = async (faceOff: any) => {
    const updatedFaceOff = { ...faceOff };
    if (faceOff.team === 'our' && isValidString(faceOff.playerId)) {
        const playerDoc = await fetchPlayerFirestoreAPI(faceOff.playerId);
        if (playerDoc.exists && !playerDoc.data()?.deleted) {
            updatedFaceOff.playerName = playerDoc.data()?.name;
        } else {
            updatedFaceOff.playerName = '';
        }
    } else {
        updatedFaceOff.playerName = '';
    }

    return updatedFaceOff;
};

export const databaseFaceOffsToLocalFaceOffs = async (faceOffs: any[]) => {
    if (isValidObject(faceOffs)) {
        const updatedFaceOffs = Array<any>(faceOffs.length);
        await (Promise.all(faceOffs.map(async (faceOff, index) => {
            updatedFaceOffs[index] = await databaseFaceOffToLocalFaceOff(faceOff);
        })));
        return updatedFaceOffs;
    }
    return [];
};

// ---------------------------------------------------------------------------------------------------------
// Turn Overs
// ---------------------------------------------------------------------------------------------------------

export const databaseTurnOverToLocalTurnOver = async (turnOver: any) => {
    const updatedTurnOver = { ...turnOver };
    if (turnOver.team === 'our' && isValidString(turnOver.playerId)) {
        const playerDoc = await fetchPlayerFirestoreAPI(turnOver.playerId);
        if (playerDoc.exists && !playerDoc.data()?.deleted) {
            updatedTurnOver.playerName = playerDoc.data()?.name;
        } else {
            updatedTurnOver.playerName = '';
        }
    } else {
        updatedTurnOver.playerName = '';
    }

    return updatedTurnOver;
};

export const databaseTurnOversToLocalTurnOvers = async (turnOvers: any[]) => {
    if (isValidObject(turnOvers)) {
        const updatedTurnOvers = Array<any>(turnOvers.length);
        await (Promise.all(turnOvers.map(async (turnOver, index) => {
            updatedTurnOvers[index] = await databaseTurnOverToLocalTurnOver(turnOver);
        })));
        return updatedTurnOvers;
    }
    return [];
};

// ---------------------------------------------------------------------------------------------------------
// Ground Balls groundBall  GroundBall
// ---------------------------------------------------------------------------------------------------------

export const databaseGroundBallToLocalGroundBall = async (groundBall: any) => {
    const updatedGroundBall = { ...groundBall };
    if (groundBall.team === 'our' && isValidString(groundBall.playerId)) {
        const playerDoc = await fetchPlayerFirestoreAPI(groundBall.playerId);
        if (playerDoc.exists && !playerDoc.data()?.deleted) {
            updatedGroundBall.playerName = playerDoc.data()?.name;
        } else {
            updatedGroundBall.playerName = '';
        }
    } else {
        updatedGroundBall.playerName = '';
    }

    return updatedGroundBall;
};

export const databaseGroundBallsToLocalGroundBalls = async (groundBalls: any[]) => {
    if (isValidObject(groundBalls)) {
        const updatedGroundBalls = Array<any>(groundBalls.length);
        await (Promise.all(groundBalls.map(async (groundBall, index) => {
            updatedGroundBalls[index] = await databaseGroundBallToLocalGroundBall(groundBall);
        })));
        return updatedGroundBalls;
    }
    return [];
};
